import ReflectionEmptyPageIcon from "./ReflectionEmptyPageIcon";

import GoalsEmptyOverlay from "../empty-pages/GoalsEmptyOverlay";
import ReflectionEmptyOverlay from "../empty-pages/ReflectionEmptyOverlay";
import ReflectionEmptySparkOverlay from "../empty-pages/ReflectionEmptySparkOverlay";
import TeamsEmptyOverlay from "../empty-pages/TeamsEmptyOverlay";
import TrackEmptyOverlay from "../empty-pages/TrackEmptyOverlay";
import TrackEmptyPageIcon from "./TrackEmptyPageIcon";

const EmptyPageIcons = {
  Track: TrackEmptyPageIcon,
  Reflection: ReflectionEmptyPageIcon,
  TrackOverlay: TrackEmptyOverlay,
  GoalsOverlay: GoalsEmptyOverlay,
  ReflectionOverlay: ReflectionEmptyOverlay,
  ReflectionSparkOverlay: ReflectionEmptySparkOverlay,
  TeamsEmptyOverlay,
};

export default EmptyPageIcons;
